<!--
 * @Author: 王枫叶
 * @Date: 2020-10-21 16:53:48
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-28 19:48:48
-->
<template>
  <div class="audiobook-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select v-model="params.isActive" size="small" placeholder="是否激活" clearable @change="getfFiction()">
        <el-option v-for="item in isActiveList" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-input placeholder="ID" size="small" clearable class="param-input" v-model="params.id" @change="getfFiction()"></el-input>
      <el-input placeholder="书名" size="small" clearable class="param-input" v-model="params.title" @change="getfFiction()"></el-input>
      <el-input placeholder="小说类型" size="small" clearable class="param-input" v-model="params.fType" @change="getfFiction()"></el-input>
      <el-button type="primary" size="small" @click="getfFiction()">搜索</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" :height='620' element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" @sort-change="handleSortChange">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="书名" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fType" label="小说类型" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.fType}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="summary" label="简介" align="center" min-width="220" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.summary}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contentUrl" label="内容地址" align="center" min-width="160" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.contentUrl}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="是否激活" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.isActive==true?'已激活':'未激活' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countPurchases" label="购买数" align="center" min-width="100" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{scope.row.countPurchases}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countBrowse" label="浏览数" align="center" min-width="100" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{scope.row.countBrowse}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countCollect" label="收藏数" align="center" min-width="100" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{scope.row.countCollect}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="编号" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.number}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="160">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="content_preview(scope.row)">小说预览</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--小说预览-->
    <preview-page ref="previewPage" @handlerChannelList="getfFiction"></preview-page>
  </div>
</template>

<script>
import API from '@/api'
import previewPage from './components/previewPage'
import { sortEscape } from '@/utils/global'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      // 系统管理列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        sortValue: '',
        sortKey: '',
      },
      imgUrl: baseConfig.imgUrl,
      isActiveList: [
        { label: '已激活', value: true },
        { label: '未激活', value: false },
      ],
    }
  },
  components: {
    previewPage,
  },
  created() {
    this.getfFiction()
  },
  methods: {
    // 请求小说列表
    getfFiction() {
      this.loading = true
      API.getfFiction(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.sortValue = sortEscape(column.order)
        this.params.sortKey = column.prop
      } else {
        this.params.sortValue = ''
        this.params.sortKey = ''
      }
      this.getfFiction()
    },
    // 打开预览弹窗
    content_preview(data) {
      this.$refs.previewPage.open(data)
    },
    //删除
    remove(id) {
      this.$confirm('您确定要删除这条信息吗？', '取消提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        API.deleteFiction({ id: id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success',
            })
            this.getfFiction()
          } else {
            this.$message.error('删除失败！')
          }
        })
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getfFiction()
    },
    // 分页页码改变回掉
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.getfFiction(this.params)
    },
  },
}
</script>

<style lang="scss" scoped>
.action-bar {
  display: flex;
}
.lf_cfg {
  .lf_cfg_content {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    div {
      margin-bottom: 10px;
      span {
        color: cadetblue;
      }
      .el-button {
        background: rgba(230, 55, 101, 0.8);
        margin-left: 20px;
        span {
          color: #ffffff;
        }
      }
    }
    .btn_style {
      padding: 4px 8px;
      color: #000000;
      background: #327720;
      border: 1px solid #999999;
      border-radius: 20px;
    }
  }
}
</style>
